import ExperimentsParser from './ExperimentsParser'
import TargetGroupsParser from './TargetGroupsParser'

const terms = {
  DATA_CONTAINER: 'data',
  APP_KEY: 'application',
  EXPERIMENTS: 'experiments',
  TARGET_GROUPS: 'targetGroups',
  SIGNED_DATE: 'signed_date',
}

export default class ConfigurationParser {
  _json
  _appKey
  _validateAppKey
  _signedDate
  _targetGroups
  _experiments
  constructor(json, appKey, validateAppKey = true) {
    if (!json || typeof json !== 'object') {
      throw new Error(
        `ConfigurationParser should be constructed with JSON object. Received ${json}`
      )
    }
    if (!appKey || typeof appKey !== 'string') {
      throw new Error(
        `ConfigurationParser should be constructed with app key string. Received ${appKey}`
      )
    }
    this._json = json
    this._appKey = appKey
    this._validateAppKey = validateAppKey
  }

  parse() {
    const data = this._extractInnerJson(this._json)
    if (this._validateAppKey && data[terms.APP_KEY] !== this._appKey) {
      return null
    }
    this._parseExperiments(data[terms.EXPERIMENTS])
    this._parseTargetGroups(data[terms.TARGET_GROUPS])
    this._signedDate = new Date(this._json[terms.SIGNED_DATE])

    return this
  }

  experiments() {
    return this._experiments || []
  }

  targetGroups() {
    return this._targetGroups || []
  }

  signedDate() {
    return this._signedDate
  }

  _extractInnerJson(json) {
    return JSON.parse(json[terms.DATA_CONTAINER])
  }

  _parseExperiments(experiments) {
    this._experiments = new ExperimentsParser(experiments).parse()
  }

  _parseTargetGroups(targetGroups) {
    this._targetGroups = new TargetGroupsParser(targetGroups).parse()
  }
}
